import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ILabResult } from '../LabResult';
import { LabTestApi } from '../../../apis/LabTestApi/LabTestApi.ts';
import { patientStore } from '../../../Store/Store.ts';

export function usePutLabTestMutations() {
    const queryClient = useQueryClient();
    const patientId = patientStore.patientId;

    return useMutation({
        mutationKey: [QueryKeys.labTests, QueryKeys.pendingLabTests],

        mutationFn: async ({ id, labResult }: { id: string; labResult: ILabResult }) => {
            await LabTestApi.updateLabTest(id, labResult);
            return { id, labResult };
        },

        onSuccess: () => {
            // Invalidate both completed and pending lab tests to refresh the data
            queryClient.invalidateQueries({ queryKey: [QueryKeys.labTests, patientId] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.pendingLabTests, patientId] });
        },
    });
} 